export const tools = [
  {
    id: 'greenArrow',
    icon: require('../assets/tools/1365.png'),
    titleUz: 'Amir Temurning harbiy yurishlari',
    titleEng: 'Military campaigns of Amir Temur',
  },
  {
    id: 'strokedBlueArrow',
    titleUz: 'Jeta (Mo’g’iliston) yurtiga qilingan eng muhim yurishlar',
    icon: require('../assets/tools/1375.png'),
    titleEng: 'The major military campaigns of Amir Temur to Jettah (Moghulistan)',
  },
  {
    id: 'greenWithTail',
    titleUz: 'Amir Temurning Eron, Ozarbayjon va Armanistonga uch yillik harbiy yurishlari',
    icon: require('../assets/tools/1386.png'),
    titleEng: '3-year campaign of Amir Temur to Iran, Azerbaijan and Armenia',
  },
  {
    id: 'strokedGreenArrow',
    titleUz: 'Jeta (Mo’g’iliston) yurtiga qilingan eng muhim yurishlar',
    icon: require('../assets/tools/1389.png'),
    titleEng: 'The major military campaigns of Amir Temur to Jettah (Moghulistan)',
  },
  {
    icon: require('../assets/tools/1391.png'),
    titleUz: "Amir Temurning To'xtamishga qarshi harbiy yurishlari",
    titleEng: 'Military campaing of Amir Temur against Tokhtamish',
    id: 'redArrow',
  },
  {
    icon: require('../assets/tools/1372.png'),
    titleUz: 'Amir Temurning Xorazmga harbiy yurishlari',
    titleEng: 'Military campaing of Amir Temur to Khorezm',
    id: 'pinkArrow',
  },
  {
    icon: require('../assets/tools/1392.png'),
    titleUz:
      "Amir Temurning Eronga, Kavkazortiga, To'xtamishga qarshi Berka Saroyga besh yillik harbiy yurishlari",
    titleEng:
      '5-year campaign of Amir Temur to Iran, the Caucasus, and Sarai Berke against Tokhtamish',
    id: 'blueArrow',
  },
  {
    icon: require('../assets/tools/1398.png'),
    titleUz: 'Amir Temurning Hindistonga harbiy yurishlari',
    titleEng: 'Military campaigns of Amir Temur to India',
    id: 'greyArrow',
  },
  {
    icon: require('../assets/tools/1399.png'),
    titleUz: 'Amir Temurning Eronga, Turkiyaga va Suriyaga yetti yillik harbiy yurishlari',
    titleEng: '7-year campaign of Amir Temur to Iran, Turkey, and Syria',
    id: 'orangeArrow',
  },
];
